var homepage4i = function () {
	var pauseIcon = "<svg class='textDkGray' width='30' height='30' focusable='false'><title>Pause Scrolling</title> <use xlink:href='#svgIcon-pause'></use> </svg>",
	playIcon = "<svg class='textDkGray rotate90' width='30' height='30' focusable='false'><title>Resume Scrolling</title> <use xlink:href='#svgIcon-arrowSolid'></use> </svg>",
	newsSignUpBtn = document.getElementById("signUpBtn"),
	homeSlider,
	initializeSlider = function(){
		homeSlider = tns({ //LAZYLOAD
			container: ".homeSlider",
			autoplay: true,
			speed: 1000,
			autoplayTimeout: 5500,
			lazyload: true, 
			controls: false,
			autoplayHoverPause: true,
			autoplayPosition: "top",
			autoplayButton: "#pausePlayBtn",
			autoplayText: [
			    playIcon,
			    pauseIcon
			]
		});
	},
	init = function(){
		initializeSlider();
		
		newsSignUpBtn.addEventListener("click", function(e){
			e.preventDefault();
			submitThisForm();
	    	});
		newsSignUpBtn.addEventListener( "keyup", function(e){
			if(e.which == 13){ newsSignUpBtn.click(); }
		});
		setTimeout(function(){
			if(lazyloadImages){
				lazyloadImages.update(); 
			}
			document.getElementById("mainSlider").classList.remove("invisible");
		}, 400);
		
		homeSlider.events.on('transitionStart', function(){
			// set the active slide button to tabindex 0 and the rest to -1 so they cannot be tabbed to
			var slider = document.getElementById("mainSlider");
			var slides = [].slice.call(slider.querySelectorAll(".tns-item"));
			slides.forEach(function(el, index, array){
				el.querySelector("a").setAttribute("tabindex", "-1");
			});
			slider.querySelector(".tns-slide-active").querySelector("a").setAttribute("tabindex", "0");
		});
		//window.addEventListener("load", function(){ onLoadInit(); });	
		//if(!window.addEventListener && window.attachEvent){ window.attachEvent('load', onLoadInit);}
	},
	submitThisForm = function(){
		// validate the email address, reusing the regex from registration
		var signupEmail = document.getElementById('signUpEmail').value;
		if (document.getElementById('hdnEmailRegex')){
			var filter = new RegExp(document.getElementById('hdnEmailRegex').value);
		}else {
			var filter = /^([\w-&]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,66}(?:\.[a-z]{2})?)$/i;
		}
		if (signupEmail === "" || signupEmail === undefined || !filter.test(signupEmail)) {
			// invalid, show the error message and highlight the textbox
			document.getElementById("signUpEmail").classList.add("input-validation-error");
			document.getElementById("signUpEmail").setAttribute("aria-invalid", "true");
			document.getElementById("signUpEmail").removeAttribute("aria-labelledby");
			document.getElementById("signUpEmail").focus();
			document.getElementById("signUpError").classList.remove("hide");
			document.getElementById("signUpError").textContent = "Please enter a valid email address";
		} else {
			// valid, submit via AJAX
			document.getElementById("signUpBtn").classList.add("hide"); // hide btn and show loading img to prevent double submit and give a visual indicator to the user
			document.getElementById("signUpLoadingImg").classList.remove("hide");
			
			var newsSignUp = ajax({
                        method: "POST",
                        url: "/esp/signup",
                        data: { EmailAddress: signupEmail }
                    });
			newsSignUp.then(function (response, xhr) {
                        	document.getElementById("signUpForm").classList.add("hide");
				document.getElementById("signUpSuccessMsg").classList.remove("hide");
				document.getElementById("signUpSuccessMsg").innerHTML = '<svg class="textGreen inlineMiddle floatLeft" height="25px" width="25px" aria-hidden="true"><use xlink:href="#svgIcon-checkMarkBox"></use></svg><p role="status" class="text16 inlineMiddle marginLeft5 textsemibold">Thank you for signing up!</p><a id="emailOpts" class="marginTop10 clear floatLeft" href="/esp/subscriptionsmanager?email=' + signupEmail + '">View all our email options</a>';
				document.getElementById("emailOpts").focus();
                    });
			newsSignUp.catch(function(response, xhr){
				document.getElementById("signUpError").classList.remove("hide");
				document.getElementById("signUpError").textContent = "Oops, something went wrong. Please submit again.";
				document.getElementById("signUpEmail").focus();
				document.getElementById("signUpBtn").classList.remove("hide");
				document.getElementById("signUpLoadingImg").classList.add("hide");
                    });
		}		
    	};
    	//onLoadInit = function() {	};
    	return {
    		init: init
    	};
};

(function(){
	var homepage = new homepage4i();
	homepage.init();
})();